module.exports = __webpack_public_path__ + "static/media/3@960w.e8f15766.jpg";